/* /assets/os-collection-header-toggle.js
 * Round 5 -- belt-and-braces redundancy for the mobile "Shop by style &
 * fit" checkbox-hack toggle (sections/os-collection-header.liquid). The
 * existing CSS-only mechanism (a hidden checkbox + a
 * :checked ~ .os-collection-header__style-row sibling selector,
 * os-theme.css) was re-traced exhaustively after two independent reports
 * described it as inert on mobile (the checkbox visibly flipped state,
 * but the row never opened) -- CSS specificity, brace balance, DOM
 * order and a check against the actual deployed file all came back
 * clean, no logical fault found in the CSS-only rule on its own.
 *
 * Rather than ship the same mechanism again on faith, this adds a
 * second, INDEPENDENT path: mirrors the checkbox's own checked state
 * onto a plain class (.os-collection-header__style-row--open) on the
 * row itself, which os-theme.css's own display rule also responds to
 * alongside the original :checked ~ selector. If the CSS-only path has
 * some issue this trace didn't catch, the class-driven path still opens
 * and closes the row; if this script never runs (JS off, error), the
 * original CSS-only mechanism is completely unchanged and untouched --
 * this is additive, not a replacement, and the toggle remains a real,
 * keyboard-operable HTML control either way.
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'os-collection-header__style-row--open';

  function init() {
    var checkboxes = document.querySelectorAll('.os-collection-header__style-row-toggle-checkbox');

    checkboxes.forEach(function (checkbox) {
      var body = checkbox.closest('.os-collection-header__body');
      var row = body ? body.querySelector('.os-collection-header__style-row') : null;
      if (!row) return;

      function sync() {
        row.classList.toggle(OPEN_CLASS, checkbox.checked);
      }

      checkbox.addEventListener('change', sync);
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
